"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAG_DELETION_WORKFLOW = exports.parseShareVisibility = exports.sharingPaths = exports.parseTagIds = exports.normalizeTagName = exports.parseTagAccessGrant = exports.parseShareRole = exports.shareCapabilitiesForRole = exports.shareVisibilityForRole = void 0;
const paths_1 = require("./paths");
const shareVisibilityForRole = (role, visibility) => (0, exports.parseShareRole)(role) === 'viewer'
    ? (0, exports.parseShareVisibility)(visibility)
    : { location: true, quantity: true };
exports.shareVisibilityForRole = shareVisibilityForRole;
const shareCapabilitiesForRole = (role, visibility) => {
    const effectiveVisibility = (0, exports.shareVisibilityForRole)(role, visibility);
    return {
        canEdit: role !== 'viewer',
        canAdd: role !== 'viewer',
        canTrash: role !== 'viewer',
        canTransferOut: role === 'editor-transfers',
        canManageTags: false,
        showQuantity: effectiveVisibility.quantity,
        showLocation: effectiveVisibility.location,
    };
};
exports.shareCapabilitiesForRole = shareCapabilitiesForRole;
const parseShareRole = (value) => {
    if (value !== 'viewer' && value !== 'editor' && value !== 'editor-transfers')
        throw new Error('Invalid sharing role.');
    return value;
};
exports.parseShareRole = parseShareRole;
const parseTagAccessGrant = (value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        throw new Error('Invalid access grant.');
    const v = value;
    const allowed = [
        'schemaVersion',
        'collectionId',
        'shareId',
        'tagId',
        'role',
        'visibility',
        'state',
        'revision',
        'kind',
        'createdAt',
        'updatedAt',
        ...(v.kind === 'link'
            ? ['linkHash', 'linkGeneration', 'linkOperationId']
            : [
                'email',
                'invitedBy',
                'invitationHash',
                'invitationState',
                'acceptedUid',
            ]),
    ];
    if (Object.keys(v).some((key) => !allowed.includes(key)))
        throw new Error('Invalid access grant fields.');
    if (v.schemaVersion !== 1 ||
        !['active', 'revoked'].includes(String(v.state)) ||
        !Number.isSafeInteger(v.revision) ||
        Number(v.revision) < 0 ||
        typeof v.collectionId !== 'string' ||
        !v.collectionId)
        throw new Error('Invalid access grant.');
    paths_1.firestorePaths.collection(v.collectionId);
    (0, paths_1.requireOperationId)(String(v.shareId));
    (0, paths_1.requireOperationId)(String(v.tagId));
    (0, exports.parseShareRole)(v.role);
    (0, exports.parseShareVisibility)(v.visibility);
    if (v.kind === 'link') {
        if (v.linkOperationId !== undefined)
            (0, paths_1.requireOperationId)(v.linkOperationId);
        if (typeof v.linkHash !== 'string' ||
            !/^[a-f0-9]{64}$/.test(v.linkHash) ||
            !Number.isSafeInteger(v.linkGeneration) ||
            Number(v.linkGeneration) < 1)
            throw new Error('Invalid link grant.');
    }
    else if (v.kind === 'person') {
        if (typeof v.email !== 'string' ||
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email) ||
            v.email !== v.email.normalize('NFKC').trim().toLowerCase() ||
            typeof v.invitedBy !== 'string' ||
            !v.invitedBy ||
            typeof v.invitationHash !== 'string' ||
            !/^[a-f0-9]{64}$/.test(v.invitationHash) ||
            !['pending', 'accepted', 'declined'].includes(String(v.invitationState)) ||
            (v.invitationState === 'accepted'
                ? typeof v.acceptedUid !== 'string' || !v.acceptedUid
                : v.acceptedUid !== undefined))
            throw new Error('Invalid person grant.');
    }
    else
        throw new Error('Invalid grant kind.');
    return {
        ...v,
        visibility: (0, exports.shareVisibilityForRole)(v.role, v.visibility),
    };
};
exports.parseTagAccessGrant = parseTagAccessGrant;
const normalizeTagName = (name) => name.normalize('NFKC').trim().toLocaleLowerCase('en-US');
exports.normalizeTagName = normalizeTagName;
const parseTagIds = (value) => {
    if (!Array.isArray(value) || value.length > 20)
        throw new Error('Select at most 20 tags.');
    const ids = value.map((id) => {
        if (typeof id !== 'string')
            throw new Error('Invalid tag.');
        return (0, paths_1.requireOperationId)(id);
    });
    if (new Set(ids).size !== ids.length)
        throw new Error('Duplicate tags.');
    return ids.sort();
};
exports.parseTagIds = parseTagIds;
exports.sharingPaths = {
    tag: (collectionId, tagId) => `${paths_1.firestorePaths.collection(collectionId)}/tags/${(0, paths_1.requireOperationId)(tagId)}`,
    share: (collectionId, shareId) => `${paths_1.firestorePaths.collection(collectionId)}/accessGrants/${(0, paths_1.requireOperationId)(shareId)}`,
    index: (userId, shareId) => `users/${paths_1.firestorePaths.member('index', userId).split('/').pop()}/sharedViews/${(0, paths_1.requireOperationId)(shareId)}`,
};
const parseShareVisibility = (value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        throw new Error('Invalid share visibility.');
    const input = value;
    if (Object.keys(input).length !== 2 ||
        typeof input.location !== 'boolean' ||
        typeof input.quantity !== 'boolean')
        throw new Error('Invalid share visibility.');
    return { location: input.location, quantity: input.quantity };
};
exports.parseShareVisibility = parseShareVisibility;
exports.TAG_DELETION_WORKFLOW = 'tag-deletion-v1';
